import { math } from 'polished';
import styled from 'styled-components';

export const StyledError = styled.small`
  color: ${({ theme }) => theme.deprecated_.colors.red};
  margin-left: ${({ theme }) => math(`${theme.deprecated_.sizeBasis} / 10`)};
  margin-top: ${({ theme }) => theme.deprecated_.sizeBasis};
  display: block;
`;
